import { useEffect, useRef } from 'react';
import { ensurePushSubscription } from '../../common/services/push.service';

interface PushSubscriptionOptions {
  participantId?: number | null;
  participantToken?: string | null;
  userId?: number | null;
  slug: string;
}

/**
 * Subscribes whoever is looking at a queue, as they arrive.
 *
 * The subscribing itself lives in push.service, shared with the account-level
 * prompt — the two must register identically or notifications end up working
 * in one part of the app and not the other.
 */
export function usePushSubscription({
  participantId,
  participantToken,
  userId,
  slug
}: PushSubscriptionOptions) {
  const subscribedRef = useRef(false);

  useEffect(() => {
    if (subscribedRef.current) return;
    if (!slug) return;
    if (!participantId && !userId) return;

    let cancelled = false;

    ensurePushSubscription({ participantId, participantToken }).then((ok) => {
      if (ok && !cancelled) subscribedRef.current = true;
    });

    return () => {
      cancelled = true;
    };
  }, [participantId, participantToken, userId, slug]);
}
